// Test IDs for the Knowledge Base feature (Phase 4F — Slice 1: read-only
// foundation). See ./index.js for the recipe.
//
// Directive:
//   - Keys are camelCase, values are kebab-case shaped as `<feature>-<element>`.
//   - Reference them in JSX as `data-testid={KNOWLEDGE_BASE.pageRoot}`.

export const KNOWLEDGE_BASE = {
	pageRoot: 'knowledge-base-page-root',
	assistantHint: 'knowledge-base-assistant-hint',
	assistantHintLink: 'knowledge-base-assistant-hint-link',
	searchInput: 'knowledge-base-search-input',
	statusFilter: 'knowledge-base-status-filter',
	loadingState: 'knowledge-base-loading-state',
	emptyState: 'knowledge-base-empty-state',
	permissionState: 'knowledge-base-permission-state',
	networkErrorState: 'knowledge-base-network-error-state',
	unexpectedErrorState: 'knowledge-base-unexpected-error-state',
	retryButton: 'knowledge-base-retry-button',
	table: 'knowledge-base-table',
	cards: 'knowledge-base-cards',
	row: 'knowledge-base-row',
	rowTitle: 'knowledge-base-row-title',
	rowFilename: 'knowledge-base-row-filename',
	rowStatus: 'knowledge-base-row-status',
	rowSize: 'knowledge-base-row-size',
	rowUpdated: 'knowledge-base-row-updated',
	rowMime: 'knowledge-base-row-mime',
	filteredEmptyState: 'knowledge-base-filtered-empty-state',
	viewDetailsButton: 'knowledge-base-view-details-button',
	detailSheet: 'knowledge-base-detail-sheet',
	detailSheetTitle: 'knowledge-base-detail-sheet-title',
	detailSheetDescription: 'knowledge-base-detail-sheet-description',
	detailCloseButton: 'knowledge-base-detail-close-button',
	detailLoading: 'knowledge-base-detail-loading',
	detailReady: 'knowledge-base-detail-ready',
	detailPermissionError: 'knowledge-base-detail-permission-error',
	detailNotFoundError: 'knowledge-base-detail-not-found-error',
	detailNetworkError: 'knowledge-base-detail-network-error',
	detailUnexpectedError: 'knowledge-base-detail-unexpected-error',
	detailFieldTitle: 'knowledge-base-detail-field-title',
	detailFieldFilename: 'knowledge-base-detail-field-filename',
	detailFieldMime: 'knowledge-base-detail-field-mime',
	detailFieldSize: 'knowledge-base-detail-field-size',
	detailFieldStatus: 'knowledge-base-detail-field-status',
	detailFieldJobStatus: 'knowledge-base-detail-field-job-status',
	detailFieldCreatedAt: 'knowledge-base-detail-field-created-at',
	detailFieldUpdatedAt: 'knowledge-base-detail-field-updated-at',
	detailFieldErrorCode: 'knowledge-base-detail-field-error-code',
	detailFieldErrorMessage: 'knowledge-base-detail-field-error-message',
	uploadButton: 'knowledge-base-upload-button',
	uploadDialog: 'knowledge-base-upload-dialog',
	uploadDialogTitle: 'knowledge-base-upload-dialog-title',
	uploadDialogDescription: 'knowledge-base-upload-dialog-description',
	uploadTitleInput: 'knowledge-base-upload-title-input',
	uploadFileInput: 'knowledge-base-upload-file-input',
	uploadSelectedName: 'knowledge-base-upload-selected-name',
	uploadSelectedType: 'knowledge-base-upload-selected-type',
	uploadSelectedSize: 'knowledge-base-upload-selected-size',
	uploadInlineMessage: 'knowledge-base-upload-inline-message',
	uploadSubmitButton: 'knowledge-base-upload-submit-button',
	uploadCancelButton: 'knowledge-base-upload-cancel-button',
	detailDeleteButton: 'knowledge-base-detail-delete-button',
	detailDeleteConfirmDialog: 'knowledge-base-detail-delete-confirm-dialog',
	detailDeleteConfirmButton: 'knowledge-base-detail-delete-confirm-button',
	detailDeleteCancelButton: 'knowledge-base-detail-delete-cancel-button',
	detailDeleteInlineMessage: 'knowledge-base-detail-delete-inline-message',
	detailRetryButton: 'knowledge-base-detail-retry-button',
	detailRetryInlineMessage: 'knowledge-base-detail-retry-inline-message',
};
